// **************************************************
// Click events
// **************************************************

function closeItems() {
  const items = document.querySelectorAll('.product-build__item.is-active');
  items.forEach((item) => {
    const openContent = item.querySelector('.product-build__content');
    item.classList.remove('is-active');
    slideUp(openContent, 300);
    const parent = item.closest('.product-build__inner');
    parent.classList.remove(parent.classList.item(1));
  });
  const btns = document.querySelectorAll('.product-build__image-button.is-active');
  btns.forEach((btn) => {
    btn.classList.remove('is-active');
  });
}

const itemTitles = document.querySelectorAll('.product-build__title');
itemTitles.forEach((itemTitle) => {
  const parent = itemTitle.closest('.product-build__inner');
  const item = itemTitle.closest('.product-build__item');
  const itemNr = item.getAttribute('data-item');
  const imageBtn = parent.querySelector(`.product-build__image-button[data-open-item="${itemNr}"]`);
  const itemContent = item.querySelector('.product-build__content');

  itemTitle.addEventListener('click', () => {
    if (item.classList.contains('is-active')) {
      closeItems();
    } else {
      closeItems();
      imageBtn.classList.add('is-active');
      item.classList.add('is-active');
      slideDown(itemContent, 300, 'block');
      parent.classList.add(itemNr);
    }
  });
});

const imageBtns = document.querySelectorAll('.product-build__image-button');
imageBtns.forEach((imageBtn) => {
  const parentDiv = imageBtn.closest('.product-build__inner');
  const parent = imageBtn.closest('.product-build');
  const itemNr = imageBtn.getAttribute('data-open-item');
  const item = parent.querySelector(`.product-build__item[data-item="${itemNr}"]`);
  const itemContent = item.querySelector('.product-build__content');

  imageBtn.addEventListener('click', () => {
    if (item.classList.contains('is-active')) {
      closeItems();
    } else {
      closeItems();
      imageBtn.classList.add('is-active');
      item.classList.add('is-active');
      slideDown(itemContent, 300, 'block');
      parentDiv.classList.add(itemNr);
    }
  });
});

// **************************************************
// Modal
// **************************************************

const openModals = document.querySelectorAll('.product-build__popup');

openModals.forEach((openModal) => {
  const modalNr = openModal.getAttribute('data-open-modal');
  const parent = openModal.closest('.product-build__item');
  const modal = parent.querySelector(`.product-build-modal[data-modal="${modalNr}"]`);
  const modalParent = modal.closest('.product-build__popup-list');
  const closeModal = modal.querySelector('.product-build-modal__close');
  const closeModalBgEle = modal.querySelector('.product-build-modal__bg');

  openModal.addEventListener('click', () => {
    document.body.appendChild(modal);
    setTimeout(() => {
      modal.classList.add('is-open-modal');
    }, 10);
  });

  closeModal.addEventListener('click', () => {
    modal.classList.remove('is-open-modal');
    setTimeout(() => {
      modalParent.appendChild(modal);
    }, 200);
  });

  closeModalBgEle.addEventListener('click', () => {
    modal.classList.remove('is-open-modal');
    setTimeout(() => {
      modalParent.appendChild(modal);
    }, 200);
  });

  // Close Modal
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      modal.classList.remove('is-open-modal');
      setTimeout(() => {
        modalParent.appendChild(modal);
      }, 200);
    }
  });
});
